// extracted by mini-css-extract-plugin
export var button = "_ev-4";
export var hasDarkBackground = "_ev-7";
export var hasLightBackground = "_ev-6";
export var iconWrapper = "_ev-0";
export var large = "_ev-2";
export var medium = "_ev-1";
export var small = "_ev-5";
export var xsmall = "_ev-3";